export const NOTES_MAX_LENGTH = 5_000;

const NOTES_RESTRICTED_PATTERNS: { pattern: RegExp; message: string }[] = [
  {
    pattern: /<\/?[a-z][^>]*>/i,
    message: 'Remove HTML tags (for example <b> or <script>); they are not allowed in messages.',
  },
  {
    pattern: /javascript:/i,
    message: 'Remove "javascript:"; it is not allowed in messages.',
  },
  {
    pattern: /\.\.[/\\]/,
    message: 'Remove "../" or "..\\" path sequences; they are not allowed in messages.',
  },
];

/**
 * Explains why free-text notes would be rejected by the API or its firewall.
 * @param notes the text the user entered
 * @returns a user-facing reason, or null when the text is acceptable
 */
export function findNotesIssue(notes: string): string | null {
  if (notes.length > NOTES_MAX_LENGTH)
    return `Message is ${notes.length - NOTES_MAX_LENGTH} characters over the ${NOTES_MAX_LENGTH}-character limit.`;
  return NOTES_RESTRICTED_PATTERNS.find(({ pattern }) => pattern.test(notes))?.message ?? null;
}
